import Vue from "vue";
import { store } from "../store";
import auth from '@websanova/vue-auth/dist/v2/vue-auth.common.js';
import authDevise from "@websanova/vue-auth/dist/drivers/auth/devise.js";
import authHttp from "@websanova/vue-auth/dist/drivers/http/axios.1.x.js";
import authRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js";

Vue.use(auth, {
  plugins: {
    http: Vue.axios, // Axios
    // // http: Vue.http, // Vue Resource
    router: Vue.router,
  },
  // DRIVERS
  drivers: {
    auth: authDevise,
    http: authHttp,
    router: authRouter
  },
  options: {
    // TOKENS
    rolesKey: "roles",
    loginData: {url: '/auth/sign_in', method: 'POST', redirect: '/', fetchUser: false},
    logoutData: {url: '/auth/sign_out', method: 'POST', redirect: '/login', fetchUser: false, makeRequest: true},
    fetchData: {url: '/user', method: 'GET', enabled: false, atInit: true},
    refreshData: { url: "/user", enabled: true, method: "GET", interval: 30 },

      // Usuário é definido no vuex sempre que for detectado pelo vue-auth
    parseUserData: function(response) {
      console.log("Usuário encontrado...");
      console.log({response});
      return response;
    },
  },
});
